import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../redux-stores/store";

const ClickableImage: React.FC<{ imageURL: string, path: string, height?: string, width?: string, rounded?: boolean }> = ({ imageURL, path, height= '200px', width= '100%', rounded=true }) => {

    const mode = useSelector((state: RootState) => state.theme.mode);

    return (
        <Link to={path} className={`d-block ${rounded ? 'rounded-4' : ''} mb-3`} style={{
            backgroundImage: `url(${imageURL})`,
            position: 'relative',
            backgroundColor: mode === 'light' ? '#000' : '#1a1c20',
            backgroundPosition: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            width,
            paddingBottom: '50%',
        }}></Link>
    )
}

export default ClickableImage